import { PageContainerRoot } from './page-container';
import { Centered } from './page-container-centered';
import { Fluid } from './page-container-fluid';

/**
 * Horizontal layout primitive. Use the variants:
 *   <PageContainer.Centered> — width-constrained, centered column
 *   <PageContainer.Fluid>    — full-bleed
 */
export const PageContainer = Object.assign(PageContainerRoot, { Centered, Fluid });

export { PAGE_CONTAINER_MAX_WIDTH } from './page-container';
export type {
  PageContainerRootProps,
  PageContainerVariantProps,
  PageContainerWidth,
} from './page-container.types';
